<template>
  <layout>
    <page-header :header="$t('graphs.earning')" />
    <div v-if="$allows('administer')" class="content dashboard">
      <filters :period="period" @change="filterChanged" />
      <b-card>
        <div class="earning-wrapper">
          <div class="earning-item">
            <canvas :id="chart.id" style="min-height: 500px;"></canvas>
          </div>
        </div>
      </b-card>
    </div>
  </layout>
</template>

<script>
import Chart from 'chart.js'
import moment from 'moment'

import Filters from './Filters'

export default {
  name: 'Earning',

  components: {
    Filters,
  },
  data() {
    return {
      period: {
        gte: moment()
          .subtract(1, 'Y')
          .format('YYYY-MM-DD'),
        lte: moment().format('YYYY-MM-DD'),
      },

      chart: {
        id: 'earning',
        type: 'line',
        data: [],
        chart: null,
        title: this.$t('graphs.earning'),
      },
    }
  },
  mounted() {
    this.updateGraph()
  },
  methods: {
    updateGraph() {
      this.$uiBlocker(
        this.$http
          .get('charts/earning', {
            params: {
              from: this.period.gte,
              to: this.period.lte,
              division_id: this.currentDivision && this.currentDivision.id,
            },
          })
          .then(({ data }) => {
            this.draw(data.earning || [])
          }),
        this.$el,
      )
    },

    draw(data) {
      const ctx = document.getElementById(this.chart.id).getContext('2d')

      const chart = this.chart.chart

      if (chart && Object.keys(chart).length !== 0) {
        chart.destroy()
      }

      if (data.length === 0) {
        return
      }
      const totals = data.map(item => item.total)
      const max = Math.max(...totals)

      this.chart.chart = new Chart(ctx, {
        type: this.chart.type,
        data: {
          labels: data.map(item => item.month),
          datasets: [
            {
              label: this.$t('graphs.total'),
              data: totals,
              fill: false,
              // mate blue background color
              backgroundColor: 'rgba(33, 150, 243, .8)',
              borderColor: 'rgba(33, 150, 243, .8)',
            },
            {
              label: this.$t('graphs.earning'),
              data: data.map(item => item.earning),
              fill: false,
              backgroundColor: 'rgba(76, 175, 80, .8)',
              borderColor: 'rgba(76, 175, 80, .8)',
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: 'top',
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label(tooltipItem, data) {
                const label =
                  data.datasets[tooltipItem.datasetIndex].label || ''

                const value = tooltipItem.yLabel
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

                if (label) {
                  return `${label}: ${value}`
                }
                return `${value}`
              },
            },
          },
          hover: {
            mode: 'nearest',
            intersect: true,
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                display: true,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: this.$t('graphs.months'),
                },
              },
            ],
            yAxes: [
              {
                min: 0,
                max,
                display: true,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: this.$t('graphs.earning'),
                },
              },
            ],
          },
        },
      })
    },

    filterChanged(params) {
      this.period.gte = moment(params.period.gte).format('YYYY-MM-DD')
      this.period.lte = moment(params.period.lte).format('YYYY-MM-DD')
      this.updateGraph()
    },
  },
}
</script>
